import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { supabase, clearSupabaseAuthStorage } from './supabaseClient';

// Global Axios Response Interceptor to handle 401 Unauthorized errors
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config?.url || "";
      if (requestUrl.includes("/auth/google/")) {
        console.warn("Global Interceptor: 401 Unauthorized detected from Google API. Skipping Supabase sign out.");
        return Promise.reject(error);
      }

      console.warn("Global Interceptor: 401 Unauthorized detected. Clearing session and redirecting to /auth.");
      clearSupabaseAuthStorage(); // Clear the storage locally first to break any redirect loop
      try {
        await supabase.auth.signOut();
      } catch (err) {
        console.error("Global Interceptor: Error during supabase.auth.signOut():", err);
      } finally {
        // Force reload and redirect to the authentication screen
        window.location.href = "/auth";
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
